import { useState } from "react";
import { Sparkles, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";

type Theme = "kovach-steele" | "sparkle";

function currentTheme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "sparkle"
    ? "sparkle"
    : "kovach-steele";
}

/** Switch between the default (kovach-steele) and Sparkle themes. Sets the
 *  data-theme attribute (CSS does the rest) and persists the choice so the
 *  pre-paint script in index.html restores it without a flash. */
export function ThemeSwitch() {
  const [theme, setTheme] = useState<Theme>(currentTheme);

  function apply(next: Theme) {
    document.documentElement.setAttribute("data-theme", next);
    try {
      localStorage.setItem("today-theme", next);
    } catch {
      /* ignore */
    }
    setTheme(next);
  }

  return (
    <div className="inline-flex items-center gap-0.5 rounded-md border p-0.5">
      <Button
        size="sm"
        variant={theme === "kovach-steele" ? "default" : "ghost"}
        onClick={() => apply("kovach-steele")}
      >
        <Sun size={14} className="mr-1.5" /> Steele
      </Button>
      <Button
        size="sm"
        variant={theme === "sparkle" ? "default" : "ghost"}
        onClick={() => apply("sparkle")}
      >
        <Sparkles size={14} className="mr-1.5" /> Sparkle
      </Button>
    </div>
  );
}
